import script from "./GfsDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./GfsDataList.vue?vue&type=script&setup=true&lang=js"

import "./GfsDataList.vue?vue&type=style&index=0&id=7bfb0308&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfb0308"]])

export default __exports__